import React from 'react'

function Chat() {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity={0.48} fill="#fff">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18 4a2 2 0 012 2v10a2 2 0 01-2 2H2a2 2 0 01-2-2V6a2 2 0 012-2h16zm-5 7a1 1 0 102 0 1 1 0 00-2 0zm-4 0a1 1 0 102 0 1 1 0 00-2 0zm-3 1a1 1 0 110-2 1 1 0 010 2z"
        />
        <path d="M19.5 2.25a.75.75 0 01-1.5 0V.75a.75.75 0 011.5 0v1.5zM21 5.25a.75.75 0 01.75-.75h1.5a.75.75 0 010 1.5h-1.5a.75.75 0 01-.75-.75zM21.468 3.53a.75.75 0 11-1.06-1.06l1.06-1.061a.75.75 0 011.06 1.06l-1.06 1.061zM9 18H3v6l6-6z" />
      </g>
    </svg>
  )
}

export default React.memo(Chat)
